import React from "react";
import { FormattedDate, FormattedPrice } from "clorian-frontend-components";
import PayoutBreakdownInfo from "../../components/PayoutBreakdownInfo";
import Cookie from "js-cookie";

export const getTableColumns = (handlePayoutPaid, view, currency) => {
  const rolesFromSessionStorage = JSON.parse(sessionStorage.getItem("roles"));
  const clientPermission = rolesFromSessionStorage.includes(
    "ROLE_AFFILIATE_CLIENT"
  );
  const locale = Cookie.get("locale") || "en";

  return [
    {
      name: "payoutId",
      label: "Payout Id",
      options: {
        sort: true,
      },
    },
    {
      name: "creationDate",
      label: "Creation Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => <FormattedDate value={value} />,
      },
    },
    {
      name: "payoutTotal",
      label: "Payout Total",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <FormattedPrice value={value} locale={locale} currency={currency} />
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        sort: true,
        customBodyRender: (status) => {
          const className =
            status === "paid" ? "label label-success" : "label label-warning";
          const text = status === "paid" ? "Paid" : "Pending Payment";
          return <span className={className}>{text}</span>;
        },
      },
    },
    ...(clientPermission && view !== "paid"
      ? generatePaymentButton(handlePayoutPaid)
      : []),
  ];
};
export const getTableOptions = () => {
  const tableOptions = {
    selectableRows: "none",
    expandableRows: true,
    isRowExpandable: (dataIndex, expandedRows) => {
      // Prevent expand/collapse of any row if there are 2 rows expanded already
      if (
        expandedRows.data.length > 2 &&
        expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
      )
        return false;
      return true;
    },
    renderExpandableRow: (rowData) => {
      const payoutId = rowData[0];
      return (
        <PayoutBreakdownInfo payoutId={payoutId} colspan={rowData.length} />
      );
    },
  };

  return tableOptions;
};

function generatePaymentButton(handlePayoutPaid) {
  return [
    {
      label: "Pay Affiliate",
      name: "Pay Affiliate",
      options: {
        customBodyRender: (value, rowData) => {
          if (rowData && rowData.rowData[3] === "pending_payment")
            return (
              <button
                className="btn btn-default btn-xs linkButtons"
                onClick={() =>
                  handlePayoutPaid(rowData.rowData[0], rowData.rowData[2])
                }
              >
                Pay
              </button>
            );

          return <span> - </span>;
        },
      },
    },
  ];
}
